/**
 * Collect all file attachments from form controls.
 *
 * Both "fileUploader" and legacy "attachment" control types use the same
 * FileUploaderControl component and store values in the same format:
 *   [ { name: "file.jpg", url: "https://..." }, ... ]
 *
 * This function iterates all controls, finds the ones that are file-upload
 * types, and concatenates their values into a single flat array.
 *
 * @param {Object} controls - formData.controls keyed by controlId
 * @param {Object} formInputData - the value container keyed by control name
 * @returns {{ attachments: Array, error: string|null }}
 */
const FILE_UPLOAD_TYPES = ['fileUploader', 'attachment'];

function collectFormAttachments(controls, formInputData) {
    const attachments = [];

    if (!controls || typeof controls !== 'object') {
        return { attachments, error: null };
    }

    for (const key in controls) {
        const control = controls[key];
        if (!control || !FILE_UPLOAD_TYPES.includes(control.type)) {
            continue;
        }

        if (!control.name || control.name.trim() === '') {
            return {
                attachments: [],
                error: 'File uploader control name is missing. Please provide a name before proceeding.'
            };
        }

        const controlName = control.name;
        const controlAttachments = formInputData ? formInputData[controlName] : undefined;

        if (Array.isArray(controlAttachments) && controlAttachments.length > 0) {
            attachments.push(...controlAttachments);
        }
    }

    return { attachments, error: null };
}

export { collectFormAttachments, FILE_UPLOAD_TYPES };
